import { Routes, UnauthenticatedRoutes, urls } from '@/constants';
import { log, logBreadcrumb } from '@/services';

export const createRouteWithParams = (route: string, params: object) => {
  let result = route;
  Object.entries(params).forEach(([key, value]) => {
    result = result.replace(`:${key}`, value);
  });
  return result;
};

export const parseUtmParameters = (search?: string) =>
  Object.fromEntries(new URLSearchParams(search).entries());

export const getRedirectSearchParams = () => {
  const { origin, pathname, search } = window.location;
  const searchParams = new URLSearchParams(search);
  searchParams.set('redirect', `${origin}${pathname}`);
  return searchParams.toString();
};

export const setRedirectSearchParams = (searchParams: URLSearchParams) => {
  const { pathname, origin } = window.location;
  const newurl = `${origin}${pathname}${searchParams.size ? '?' + searchParams.toString() : ''}`;
  window.history.pushState({ path: newurl }, '', newurl);
};

export const parseRedirectUrl = () => {
  const { origin, search, href, pathname } = window.location || {};
  logBreadcrumb({ data: { href } });

  const defaultRedirect = `${origin}${Routes.DISCOVER}`;

  try {
    const searchParams = Object.fromEntries(
      new URLSearchParams(search).entries(),
    );
    logBreadcrumb({ data: { searchParams } });

    // Check for redirect param, or set as current page if logging in via modal
    const redirectUrlString =
      searchParams.redirect ||
      searchParams.luminariRedirect ||
      (!Object.values(UnauthenticatedRoutes).includes(pathname) && href) ||
      defaultRedirect;

    const redirectUrl = new URL(redirectUrlString);

    if (redirectUrl.origin !== origin) {
      // log error but proceed by changing redirectUrl to current origin
      log(
        new Error(
          `Attempted to redirect to different origin: ${redirectUrl.href}`,
        ),
      );
    }

    const redirectUrlWithCurrentOrigin = new URL(
      redirectUrlString.replace(redirectUrl.origin, origin),
    );

    delete searchParams.redirect;
    delete searchParams.luminariRedirect;

    const newSearchParams = {
      ...searchParams,
      ...Object.fromEntries(
        new URLSearchParams(redirectUrlWithCurrentOrigin.search).entries(),
      ),
    };

    redirectUrlWithCurrentOrigin.search = new URLSearchParams(
      newSearchParams,
    ).toString();

    return redirectUrlWithCurrentOrigin.toString();
  } catch (error) {
    log(new Error('Unable to parse redirect URL', { cause: error }));
    return defaultRedirect; // TODO discuss what to do here
  }
};

export const getOauthURL = (
  service: keyof typeof urls.auth,
  marketingConsent?: boolean,
) => {
  const redirectUrl = parseRedirectUrl();
  const params: Record<string, string> = { redirect: redirectUrl };
  params.marketing_consent = `${marketingConsent === false}`;

  return `${urls.auth[service]}?${new URLSearchParams(params).toString()}`;
};
